import { render, staticRenderFns } from "./Talk.vue?vue&type=template&id=0a8a3b42&scoped=true&"
import script from "../../models/communication/talk.ts?vue&type=script&lang=ts&"
export * from "../../models/communication/talk.ts?vue&type=script&lang=ts&"
import style0 from "./Talk.vue?vue&type=style&index=0&id=0a8a3b42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8a3b42",
  null
  
)

export default component.exports